import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Finance.AccountReceivable.StatementCandidates.IRequest;
type Response = Api.Finance.AccountReceivable.StatementCandidates.IResponse;
type Headers = Api.Finance.AccountReceivable.StatementCandidates.IHeaders;
const url = '/api/Finance/AccountReceivable/StatementCandidates';
export default async function accountReceivableStatementCandidatesApi(query?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, null, query),
    headers: getDefaultHeaders(),
  });
}
